import React from 'react';
import CoreMaps from 'gatsby-theme-core/src/components/maps';
import Column from '../../column';

const Maps = ({
  // id,
  columnWidth,
  align,
  order,
  offset,
  name,
  street,
  houseNumber,
  city,
}) => (
  <Column
    columnWidth={columnWidth}
    align={align}
    order={order}
    offset={offset}
  >
    <CoreMaps
      name={name}
      street={street}
      houseNumber={houseNumber}
      city={city}
    />
  </Column>
);

export default Maps;
